import {
  mdiArchivePlus,
  mdiCalendarMultiple,
  mdiCameraMarker,
  mdiCashMultiple,
  mdiSaleOutline,
} from '@mdi/js'

export default [

  {
    title: 'Citas',
    icon: mdiCalendarMultiple,
    to: 'bookings-list',
  },
  {
    title: 'Pagos',
    icon: mdiCashMultiple,
    to: 'payments-list',
  },
  {
    title: 'Add Ons',
    icon: mdiArchivePlus,
    to: 'addOns-list',
  },
  {
    title: 'Promos',
    icon: mdiSaleOutline,
    to: 'promos-list',
  },
  {
    title: 'Eventos',
    icon: mdiCameraMarker,
    to: 'events-list',
  },
]
